import React from "react";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import Banner from "../../assets/images/banner.jpg";
import { TypeAnimation } from "react-type-animation";

export const HomeBannerSection = ({ scrollToSection, onImageLoad }) => {
  return (
    <section className="banner-section">
      <div className="banner">
        <img
          src={Banner}
          onLoad={onImageLoad}
          alt="Banner"
          className="banner-image"
        />
        <div className="text-cutout">
          <TypeAnimation
            style={{
              whiteSpace: "pre-line",
              display: "block",
              width: "300px",
            }}
            wrapper="p"
            speed={30}
            sequence={[
              "BUILDING THE FUTURE.",
              1000,
              `BUILDING THE FUTURE.\nRESTORING THE PAST.`,
            ]}
          />
          <MdKeyboardDoubleArrowDown
            onClick={() => scrollToSection("intro-section", 50)}
            size={30}
            className="icon-bounce-animation"
          />
        </div>
      </div>
    </section>
  );
};
